import React from 'react';

const SectionTitle = ({ children, accent, className = '' }) => (
  <div className={`relative mb-6 ${className}`}>
    <div className="flex items-end gap-3 pb-2 border-b border-gray-200">
      <h3
        className="text-[16px] font-bold uppercase tracking-[0.18em] text-[#1a1414]"
        style={{ fontFamily: "'Inter', sans-serif" }}
      >
        {children}
        {accent && <span className="text-[#8b2c3f] ml-1 italic font-semibold">{accent}</span>}
      </h3>
    </div>
    {/* Gold signature underline */}
    <div className="absolute bottom-[-2px] left-0 h-[3px] w-14 bg-[#c9a961]" />
  </div>
);

export default SectionTitle;
